module.exports = __webpack_public_path__ + "static/media/tama.acdfa6ee.jpg";